import { render, staticRenderFns } from "./ScoreUser.vue?vue&type=template&id=3fbe0a36&"
import script from "./ScoreUser.vue?vue&type=script&lang=js&"
export * from "./ScoreUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports